<template>
  <v-card color="white" class="rounded">
    <v-card-title class="mb-0">
      <h4 class="subheading">Create a new Organization</h4>
    </v-card-title>
    <v-card-text class="pt-0">
      <div
        v-if="!$store.getters.isCurrentOrgChild || $store.getters.isSuperAdmin"
      >
        <v-form
          v-model="FormValid"
          v-on:submit.prevent="createOrganization"
          ref="form"
        >
          <v-text-field
            class="mb-3"
            v-model="newOrganization.name"
            label="New organization name"
            :rules="organizationNameRules"
            :hint="showHint"
            persistent-hint
          ></v-text-field>
          <v-btn
            class="btn-rounded-medium white--text"
            color="#d13b55"
            @click.prevent="createOrganization"
            :disabled="!FormValid"
          >
            Create
          </v-btn>
        </v-form>
      </div>
      <div v-else>
        <v-alert :value="true" outline type="warning" icon="warning"
          >Creating a new org under any sub/team org is not supported.</v-alert
        >
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";

export default {
  name: "OrganizationCreateComponent",
  data() {
    return {
      newOrganization: {},
      FormValid: true,
      organizationNameRules: validationRules.organizationNameRules,
    };
  },
  computed: {
    showHint: function () {
      if (this.$store.getters.isSuperAdmin) {
        return "";
      } else {
        return (
          "New org name will be: " +
          this.$store.getters.getCurrentOrgName +
          "-" +
          (this.newOrganization.name ? this.newOrganization.name : "")
        );
      }
    },
  },
  methods: {
    createOrganization: function () {
      // Disable form submission while async call takes place
      this.FormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Creating new organization...",
        messageType: "warning",
      });

      const params = this.newOrganization;

      axios
        .post("/api/org", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Allow form submission
          this.FormValid = true;

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message:
              "New Organization Created. You have been switched to this Organization.",
          });

          // reset the form
          this.$refs.form.reset();

          // TODO: Update Organizations component, if shown.
        })
        .catch((e) => {
          // Allow form submission
          this.FormValid = true;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization was NOT created.<br><strong>" +
              e.response.data.message +
              "</strong><br>Error #KNI484",
            messageType: "error",
          });
        });
    },
  },
};
</script>
